import { useBrand } from "hooks/useBrand";
import React from "react";
import { useTranslation } from "react-i18next";

import type { FaqItemProps } from "./helpSupport.types";

import styles from "./FaqItem.module.css";

const FaqItem = ({ entryKey }: FaqItemProps) => {
	const { t } = useTranslation("helpSupportPage");
	const brand = useBrand();

	return (
		<details className={styles.item}>
			<summary className={styles.question}>
				<span>{t(`faq.${entryKey}.question`, brand)}</span>
				<span aria-hidden="true" className={styles.marker} />
			</summary>
			<p className={styles.answer}>{t(`faq.${entryKey}.answer`, brand)}</p>
		</details>
	);
};

export default FaqItem;
